import { useMemo } from 'react';
import { generateGuid } from '../helpers/RandomGenerator';
export default function useGuid(prefix, deps) {
    if (prefix === void 0) { prefix = ''; }
    if (deps === void 0) { deps = []; }
    return useMemo(function () { return "" + prefix + generateGuid(); }, deps);
}
//# sourceMappingURL=UseGuid.js.map